<template>
    <BootstrapModal ref="modal">
        <div class="modal-header pb-0">
            <CloseButton @click="dismiss" class="ml-auto"/>
        </div>
        <div v-if="user || subscriptionOptions" class="modal-body">
            <div v-if="user" class="d-block mx-auto user-avatar user-avatar-xl bg-gray mb-2">
                <img :src="user.profile_image_url" alt="" style="background-color:#CCC;">
            </div>
            <h5 class="text-center mb-0">Subscribe to {{ user.display_name }}</h5>
            <p class="text-center mb-3">Select an option to get Exclusive Access</p>
            <div class="form-group">
                <div class="input-group input-group-alt">
                    <input id="promo_code" type="text" v-model="promoCode" placeholder="Promo Code" class="form-control"/>
                    <div class="input-group-append">
                        <button type="button" @click="applyPromoCode()" class="btn btn-secondary">
                            Apply <span class="d-none d-sm-inline">Promo Code</span>
                        </button>
                    </div>
                </div>
                <small v-if="promoCodeMessage" v-html="promoCodeMessage" class="d-block"></small>
            </div>
            <div v-if="!isLoading && subscriptionOptions" class="form-group">

                <div v-for="subscriptionOption in subscriptionOptions" class="subscription-option p-2" :class="{'subscription-option-selected': selectedSubscriptionOptionId === subscriptionOption.id}">
                    <div @click="selectSubscriptionOption(subscriptionOption)">

                        <!-- promo -->
                        <div v-if="subscriptionOption.has_promo_code" class="subscription-option-promo mx-n2 mt-n2 mb-1 p-2">
                            <i class="fa fa-star"></i> <b>Promo: {{ lastPromoCode }}</b>
                        </div>

                        <div class="d-flex">

                            <!-- subscription info -->
                            <div class="w-100">
                                <b>{{ subscriptionOption.title }}</b>
                                <div v-if="subscriptionOption.description">{{ subscriptionOption.description }}</div>
                                <div class="d-block">
                                    <span v-if="subscriptionOption.trial_amount" class="badge subscription-option-trial-badge">
                                        ${{ subscriptionOption.trial_amount }} for {{ subscriptionOption.trial_duration_in_days }} day trial
                                    </span>
                                    <span>
                                        <span v-if="subscriptionOption.trial_amount">then</span>
                                        <span>${{ subscriptionOption.amount }} every {{ subscriptionOption.duration_in_days }} days.</span>
                                    </span>
                                </div>
                            </div>

                            <!-- checkbox -->
                            <div class="ml-2">
                                <div class="subscription-option-checkbox">
                                    <i v-if="selectedSubscriptionOptionId === subscriptionOption.id" class="fa fa-2x fa-check-circle"></i>
                                    <i v-else class="fa fa-2x fa-circle-o"></i>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="mt-3 d-flex">
                    <button @click="subscribe(selectedSubscriptionOptionId)" type="button" class="btn rounded-pill w-100" :disabled="selectedSubscriptionOptionId === null || isRedirecting" :class="{'btn-primary': selectedSubscriptionOptionId != null, 'btn-secondary': selectedSubscriptionOptionId === null}">
                        <span v-if="isRedirecting"><i class="fa fa-spin fa-spinner"></i> Redirecting...</span>
                        <span v-else>Subscribe Now</span>
                    </button>
                </div>

            </div>
        </div>
        <div v-if="isLoading" class="text-center mb-4">
            <i class="fad fa-2x fa-spin fa-spin-fast fa-spinner-third mb-2"></i>
            <div>Loading Subscription Options</div>
        </div>
    </BootstrapModal>
</template>

<style scoped>
.subscription-option {
    border: solid 2px #DDDDDD;
    border-radius: 8px;
    margin-bottom: 0.5rem;
    cursor: pointer;
}

.subscription-option-promo {
    background-color: rgb(247, 196, 108, 0.75);
    border-radius: 6px 6px 0 0;
    border-bottom: solid 1px #DDDDDD;
    padding: 0.25rem;
}

.subscription-option-checkbox {
    color: #DDDDDD;
}

.subscription-option-selected .subscription-option-checkbox {
    color: #00BFA5;
}

.subscription-option-selected {
    border: solid 2px #00BFA5;
    background-color: rgb(0, 191, 165, 0.1);
}

.subscription-option-trial-badge {
    color: #363642;
    background-color: #d7dce5;
}

/* Devices that can hover (desktops) */
@media (hover: hover) {

    .subscription-option:hover .subscription-option-checkbox {
        color: #00BFA5;
    }

    .subscription-option:hover {
        border: solid 2px #00BFA5;
        background-color: rgb(0, 191, 165, 0.1);
    }

}

</style>

<script>
    import BootstrapModal from "./Modals/BootstrapModal";
    import CloseButton from "./Modals/CloseButton";
    export default {
        components: {
            CloseButton,
            BootstrapModal,
        },
        data: function() {
            return {
                isLoading: true,
                isRedirecting: false,
                userId: null,
                user: null,
                subscriptionOptions: null,
                promoCode: null,
                lastPromoCode: null,
                promoCodeMessage: null,
                selectedSubscriptionOptionId: null,
            }
        },
        mounted() {

            // cancel redirecting state when navigating back
            window.addEventListener('pageshow', event => {
                if(event.persisted){
                    this.isRedirecting = false;
                }
            });

        },
        methods: {
            show: function(userId) {
                this.reset();
                this.userId = userId;
                this.$refs.modal.show();
                this.load();
            },
            reset: function() {
                this.isRedirecting = false;
                this.user = null;
                this.subscriptionOptions = null;
                this.promoCode = null;
                this.promoCodeMessage = null;
                this.selectedSubscriptionOptionId = null;
            },
            dismiss: function() {
                this.$refs.modal.hide();
            },
            applyPromoCode: function() {
                this.load(this.promoCode);
            },
            selectSubscriptionOption: function(subscriptionOption) {

                // unselect if already selected
                if(this.selectedSubscriptionOptionId === subscriptionOption.id){
                    this.selectedSubscriptionOptionId = null;
                    return;
                }

                // select subscription option
                this.selectedSubscriptionOptionId = subscriptionOption.id;

            },
            load: function(promoCode) {

                this.isLoading = true;

                axios.post(route('web-api.users.subscription-options', this.userId), {
                    'promo_code': promoCode,
                }).then((response) => {

                    const json = response.data;
                    this.user = json.user;
                    this.subscriptionOptions = json.subscription_options;

                    // update last promo code
                    this.lastPromoCode = promoCode;

                    // check if we have a valid promo code
                    if(this.promoCode){
                        if(this.subscriptionOptions.find(subscriptionOption => subscriptionOption.has_promo_code === true)){
                            this.promoCodeMessage = '<span class="text-success">Promo Code Applied!</span>';
                        } else {
                            this.promoCodeMessage = '<span class="text-red">Invalid Promo Code!</span>';
                        }
                    } else {
                        this.promoCodeMessage = null;
                    }

                }).catch((error) => {
                    this.dismiss();
                    alert(error);
                }).then(() => {
                    this.isLoading = false;
                });

            },
            subscribe: function(subscriptionOptionId) {

                // do nothing if already redirecting
                if(this.isRedirecting){
                    return;
                }

                this.isRedirecting = true;

                // fetch subscribe url for subscription option
                axios.post(route('web-api.v1.subscription-options.subscribe', subscriptionOptionId)).then((response) => {
                    const json = response.data;
                    window.location = json.redirect;
                }).catch((error) => {

                    this.isRedirecting = false;

                    var message = "Something went wrong... Please try again later.";

                    // try to get error message from response
                    if(error && error.response && error.response.data){
                        var json = error.response.data;
                        if(json.message){
                            message = json.message;
                        }
                    }

                    alert(message);

                });

            }
        },
    }
</script>
